import { Button, Card, CardContent } from "@roberttamas/ui";
import { useTranslation } from "react-i18next";

import { Sparkles } from "@/components/icons";

/**
 * Milestone screen shown once, right after step 1 creates the page:
 * reassures the buyer their page is already live with defaults, then
 * lets them keep going or finish from the dashboard later. Not a
 * wizard step — it never appears in the stepper or the edit pages.
 */
export function SetupInterlude({
  onContinue,
  onFinishLater,
}: {
  onContinue: () => void;
  onFinishLater: () => void;
}) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent className="space-y-6 pt-6">
        <div className="space-y-1 text-center">
          <Sparkles className="mx-auto h-10 w-10 rounded-full bg-primary/10 p-2 text-primary" />
          <h1 className="text-2xl font-semibold">{t("setup.interlude.title")}</h1>
          <p className="mx-auto max-w-md text-sm text-muted-foreground">
            {t("setup.interlude.body")}
          </p>
        </div>

        <div className="flex flex-col items-center gap-3">
          <Button type="button" size="lg" onClick={onContinue}>
            {t("setup.interlude.continue")}
          </Button>
          <Button type="button" variant="outline" onClick={onFinishLater}>
            {t("setup.interlude.finishLater")}
          </Button>
          <p className="text-xs text-muted-foreground">
            {t("setup.interlude.note")}
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
